const ROOT = 'StepTwo/channelPublication/print';

export const FETCH_PRINT_REQUEST = `${ROOT}/FETCH_PRINT_REQUEST`;
export const FETCH_PRINT_FAILURE = `${ROOT}/FETCH_PRINT_FAILURE`;
export const FETCH_PRINT_SUCCESS = `${ROOT}/FETCH_PRINT_SUCCESS`;

export const SET_PRINT_GENERAL = `${ROOT}/SET_PRINT_GENERAL`;
export const SET_PRINT_DATA = `${ROOT}/SET_PRINT_DATA`;
export const SET_PRINT_ALL_BY_CHANNEL = `${ROOT}/SET_PRINT_ALL_BY_CHANNEL`;
export const SET_PRINT_EXTRAWORDS = `${ROOT}/SET_PRINT_EXTRAWORDS`;

export const CLEAN_PRINT_GENERAL = `${ROOT}/CLEAN_PRINT_GENERAL`;
export const CLEAN_PRINT_SUMMARY_ID = `${ROOT}/CLEAN_PRINT_SUMMARY_ID`;
export const DELETE_PRINT_ALL_BY_CHANNEL = `${ROOT}/DELETE_PRINT_ALL_BY_CHANNEL`;
export const CLEAR_PRINT_DATA = `${ROOT}/CLEAR_PRINT_DATA`;